import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AppLayoutComponent } from './app-layout/app-layout.component';
import { LanguageSelectorComponent } from './app-layout/footer/language-selector/language-selector.component';
import { BasketComponent } from './app-layout/header/basket/basket.component';
import { HeaderComponent } from './app-layout/header/header.component';
import { FooterComponent } from './app-layout/footer/footer.component';
import { DapUiModule } from 'dap-ui-library';
import { BaseOverlayComponent } from './base-overlay/base-overlay.component';
import { BaseVerticalOverlayComponent } from './base-vertical-overlay/base-vertical-overlay.component';
import { BulletListComponent } from './bullet-list/bullet-list.component';
import { PersonComponent } from './personal-data/person/person.component';
import { CarouselComponent } from './carousel/carousel.component';
import { BasketPersonDetailComponent } from './app-layout/header/basket/basket-person-detail/basket-person-detail.component';
import { SinglePersonItemComponent } from './app-layout/header/basket/single-person-item/single-person-item.component';
import { BasketAccordionComponent } from './app-layout/header/basket/basket-accordion/basket-accordion.component';
import { DevToolsComponent } from './dev-tools/dev-tools.component';
import { LayoutedOverlayComponent } from './layouted-overlay/layouted-overlay.component';
import { LayoutedVerticalOverlayComponent } from './layouted-vertical-overlay/layouted-vertical-overlay.component';
import { MedicalOfficeAddressComponent } from './medical-office-address/medical-office-address.component';
import { CardPriceComponent } from './card/card-price/card-price.component';
import { InsuranceSelectionOverlayComponent } from './insurance-selection-overlay/insurance-selection-overlay.component';
import { UlComponent } from './ul/ul.component';
import { PriceComponent } from './price/price.component';
import { AnchorScrollDirective } from './directives/anchor-scroll.directive';
import { ContactBannerComponent } from './contact-banner/contact-banner.component';
import { ContactOverlayComponent } from './contact-overlay/contact-overlay.component';
import { ContactOverlayContentComponent } from './contact-overlay/contact-overlay-content/contact-overlay-content.component';
import { SelectionNavigationBarComponent } from './selection-navigation-bar/selection-navigation-bar.component';
import { RouterModule } from '@angular/router';
import { PolicyholderComponent } from './policyholder/policyholder.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PersonalAddressComponent } from './personal-address/personal-address.component';
import { PersonalDataComponent } from './personal-data/personal-data.component';
import { CapitalizeDirective } from './directives/capitalize.directive';
import { TranslateProductConfigurationPipe } from './pipes/product-configuration.pipe';
import { ApiLanguageSelectorComponent } from './api-language-selector/api-language-selector.component';
import { ErrorPopupComponent } from './error-popup/error-popup.component';
import { PersonDataComponent } from './person-data/person-data.component';
import { CoverageSelectionComponent } from './coverage-selection/coverage-selection.component';
import { SaleOfferBeginDropdownComponent } from './sale-offer-begin-dropdown/sale-offer-begin-dropdown.component';
import { ZipCodeAutocompleteComponent } from './zip-code-autocomplete/zip-code-autocomplete.component';
import { ExistingCustomerToggleComponent } from './existing-customer-toggle/existing-customer-toggle.component';
import { FrameworkContractAutocompleteComponent } from './framework-contract-autocomplete/framework-contract-autocomplete.component';
import { HtmlEntityDecodePipe } from './pipes/HtmlEntityDecodePipe';
import { IntersectionObserverDirective } from './directives/intersection-observer-directive';
import { ContactBtnComponent } from './contact-btn/contact-btn.component';

const sharedComponents = [
  AppLayoutComponent,
  AnchorScrollDirective,
  CapitalizeDirective,
  IntersectionObserverDirective,
  CarouselComponent,
  DevToolsComponent,
  HeaderComponent,
  PersonComponent,
  CardPriceComponent,
  BulletListComponent,
  BulletListComponent,
  BaseOverlayComponent,
  BaseVerticalOverlayComponent,
  LayoutedOverlayComponent,
  LayoutedVerticalOverlayComponent,
  MedicalOfficeAddressComponent,
  InsuranceSelectionOverlayComponent,
  UlComponent,
  PriceComponent,
  ContactBannerComponent,
  ContactBtnComponent,
  ContactOverlayComponent,
  SelectionNavigationBarComponent,
  PolicyholderComponent,
  PersonDataComponent,
  SaleOfferBeginDropdownComponent,
  ZipCodeAutocompleteComponent,
  CoverageSelectionComponent,
  PersonalAddressComponent,
  PersonalDataComponent,
  TranslateProductConfigurationPipe,
  HtmlEntityDecodePipe,
  ApiLanguageSelectorComponent,
  ErrorPopupComponent,
  ExistingCustomerToggleComponent,
];

@NgModule({
  declarations: [
    ...sharedComponents,
    FooterComponent,
    LanguageSelectorComponent,
    BasketComponent,
    BasketPersonDetailComponent,
    SinglePersonItemComponent,
    BasketAccordionComponent,
    ContactOverlayContentComponent,
    FrameworkContractAutocompleteComponent,
  ],
  imports: [CommonModule, TranslateModule, DapUiModule, RouterModule, ReactiveFormsModule],
  providers: [DecimalPipe],
  exports: [...sharedComponents, FrameworkContractAutocompleteComponent],
  schemas: [],
})
export class SharedModule {}
